<!--
    USE IN: Transfers
-->
<script>
    import R from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import ControlLoader from "../ControlLoader.svelte";

    export let location = null;
    export let placeholder = '';
    export let css = '';

    let locationId = null;
    let name = '';
    let timer;
    let results = [];
    let listIndex = -1;
    let showDropdown = false;
    let loading = false;

    const dispatch = createEventDispatcher();

    const search = () => {
        const onSuccess = result => {
            results = result;
            loading = false;
            openDropdown();
        }

        const onFailure = err => {
            loading = false;
        };

        loading = true;
        R.handle(R.location.index, {name}, onSuccess, onFailure);
    }

    const onFocusOut = () => {
        if (location) {
            name = location.name;
        }
    }

    const onKeyDown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter') {
                event.preventDefault();
                if (timer) {
                    clearInterval(timer);
                }
                if (listIndex > -1) {
                    onSelect(results[listIndex]);
                } else {
                    closeDropdown();
                }
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    const onKeyUp = (event) => {
        if (name != event.target.value) {
            name = event.target.value;
            if (timer) {
                clearInterval(timer);
            }

            if (name.length) {
                timer = setInterval(() => {
                    clearInterval(timer);
                    search();
                }, 500);
            } else {
                clear();
            }
        }
    }

    const clear = () => {
        location = null;
        locationId = null;
        dispatch("change");
    }

    const onSelect = (item) => {
        location = item;
        name = location.name;
        dispatch("change", location);
        closeDropdown();
    }

    const openDropdown = () => {
        showDropdown = true;
    }

    const closeDropdown = () => {
        showDropdown = false;
    }

    $: {
        if (location) {
            if (locationId != location.id) {
                locationId = location.id;
                name = location.name;
            }
        } else {
            if (locationId != null && !location) {
                locationId = null;
                name = '';
            }
        }
    }
</script>

<div class="dropdown-container" use:clickOutside on:click_outside="{ closeDropdown }">
    <input type="text" class="form-control {css}" id="locationName" value="{ name }" on:keydown="{ onKeyDown }" on:keyup="{ onKeyUp }"
           on:focusout="{ onFocusOut }"
           autocomplete="off"
           {placeholder}>

    <ControlLoader {loading}/>

    {#if showDropdown}
        {#if results.length}
            <ul class="dropdown">
                {#each results as item, index}
                    <li class="dropdown-item pointer" class:selected="{ listIndex === index }"
                        on:click="{ () => onSelect(item) }">
                        { item.name }
                    </li>
                {/each}
            </ul>
        {/if}
    {/if}
</div>